import { render, staticRenderFns } from "./TrunkVisual.vue?vue&type=template&id=5ea40ef2&scoped=true&"
import script from "./TrunkVisual.vue?vue&type=script&lang=js&"
export * from "./TrunkVisual.vue?vue&type=script&lang=js&"
import style0 from "./TrunkVisual.vue?vue&type=style&index=0&id=5ea40ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea40ef2",
  null
  
)

export default component.exports